/* eslint-disable i18next/no-literal-string */
import React from 'react';
import bgImage from 'assets/images/gen-ai-image-landing/testimonial/bg.jpg';
import graphicImage from 'assets/images/gen-ai-image-landing/testimonial/graphic.png';
import avatarImage from 'assets/images/gen-ai-image-landing/testimonial/avatar.png';
import styles from './Testimonial.module.scss';

export default function Testimonial() {
  return (
    <div
      className={styles.testimonialSection}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className={styles.testimonialCard}>
        <div className={styles.testimonialImage}>
          <img src={graphicImage} alt="Interior design transformation" />
        </div>

        <div className={styles.testimonialContent}>
          <p className={styles.testimonialText}>
            Transforming my living room with decor from Decor A Living Room
            has been a game changer! The vibrant colors and unique designs
            have truly brought my space to life. I love how the pieces blend
            seamlessly, creating a cozy yet stylish atmosphere. Highly
            recommend for anyone looking to refresh their home!
          </p>

          <div className={styles.testimonialAuthor}>
            <img src={avatarImage} alt="David James" className={styles.avatar} />
            <div className={styles.authorInfo}>
              <div className={styles.authorName}>David James</div>
              <div className={styles.authorTitle}>Father of 2 sons</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
